import PropTypes from 'prop-types';
import React from 'react';
import StimulusButton from '../stimulus/StimulusButton';
import { VOCAB_BREAK } from '../../constants/regExp';

const responseGap = '{{response}}';

export default class FITBQuestionInput extends React.Component {
    static getTextWithBreak(line) {
        return line.split(VOCAB_BREAK).map((element, index, array) => {
            const divider = index < (array.length - 1) ? <br /> : null;

            /* eslint-disable react/no-array-index-key */
            return (
                <span
                    key={`text-${index}`}
                    aria-label={element}>
                    {element}
                    {divider}
                </span>
            );
        });
    }

    constructor(props) {
        super(props);

        this.responseRegExp = new RegExp(`(.*?)(${responseGap})(.*)`);
    }

    getQuestion() {
        const { id, stimulus: { text } } = this.props;

        return (
            <div className="stimulus-text" aria-live="polite">
                {text.split(this.responseRegExp).map((snippet) => (snippet === responseGap
                    ? (
                        <input
                            key={id}
                            type="text"
                            tabIndex="-1"
                            className="blank-input"
                            readOnly={true}
                            size={this.props.inputSize + 1}
                            value={this.props.selectedResponseText}
                            aria-label="Select the correct answer from the choices below"
                        />
                    )
                    : FITBQuestionInput.getTextWithBreak(snippet)))}
            </div>
        );
    }

    render() {
        return (
            <div>
                <StimulusButton
                    isDisabled={this.props.isDisabled}
                    styles="stimulus-top"
                    isPlaying={this.props.isStimulusPlaying}
                    onClick={this.props.playStimulus}
                />
                {this.getQuestion()}
            </div>
        );
    }
}

FITBQuestionInput.propTypes = {
    id: PropTypes.string,
    inputSize: PropTypes.number,
    isStimulusPlaying: PropTypes.bool,
    isDisabled: PropTypes.bool,
    selectedResponseText: PropTypes.string,
    stimulus: PropTypes.object,
    playStimulus: PropTypes.func,
};

FITBQuestionInput.defaultProps = {
    id: '',
    inputSize: null,
    isDisabled: false,
    isStimulusPlaying: false,
    selectedResponseText: undefined,
    stimulus: undefined,
    playStimulus: () => {},
};
